import React, { useEffect, 
    useMemo, 
    useState 
} from 'react';
import { useHistory } from 'react-router-dom';
import { usePagesContext } from '../context/PagesContext';
import { EVENT_TYPES_OPTIONS, NOT_DELETABLE_PAGES } from '../constants';
import { capitalizer } from '../../../../utils';
import locale from '../../../../locale';
import { ButtonToolbar, FormControl, FormGroup, Button, Glyphicon } from 'react-bootstrap';
import useClickOutside from '../../../../hooks/useClickOutside';

const PagesListTableItem = ({page, onVisibilityUpdate, onUpdateDefaultType}) => {
    const history = useHistory();
    const pagesContext = usePagesContext();

    const isNotDeletablePageType = useMemo(() => {
        return NOT_DELETABLE_PAGES.includes(page.type);
    }, [page]);

    const [isEditing, setIsEditing] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('ru');
    const [namePage, setNamePage] = useState(page[`title${capitalizer(selectedLanguage)}`]);

    const editLocaleName = (e) => {
        e.stopPropagation();
        setIsEditing(true);
    }

    const handleTitleChange = (e) => {
        setNamePage(e.target.value);
    }

    const saveChanges = () => {
        pagesContext.handleUpdatePage({...page, [`title${capitalizer(selectedLanguage)}`]: namePage})
        setIsEditing(false);
    }

    const handleLanguageChange = (e) => {
        setSelectedLanguage(e.target.value);
    }

    useEffect(() => {
        setNamePage(page[`title${capitalizer(selectedLanguage)}`]);
    }, [selectedLanguage]);

    const ref = useClickOutside(saveChanges)

    return (
        <>
            <td style={{verticalAlign: 'middle'}}>
                {
                    !isNotDeletablePageType &&
                    <Glyphicon glyph="resize-vertical" />
                }
            </td>
            <td 
                style={{ display: 'flex' }}
            > 
                {isEditing ? (
                    <div 
                        ref={ref}
                        style={{ display: 'flex' }}
                    >
                        <FormControl
                            type="text"
                            value={namePage}
                            onChange={handleTitleChange}
                        />
                        <select value={selectedLanguage} onChange={handleLanguageChange}>
                            <option value="ru">RU</option>
                            <option value="en">EN</option>
                        </select>
                    </div>
                    
                ) : (
                    <>
                        {namePage}
                        {page.sortOrder !=0 && (<div
                            style={{ marginLeft: 'auto', cursor: 'pointer' }}
                            onClick={editLocaleName}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                            </svg>
                        </div>)}
                    </>
                )}
            </td>
            <td>
                {
                    !isNotDeletablePageType &&
                    <FormGroup
                        controlId="open-for-participant"
                        bsSize="sm"
                    >
                        <FormControl
                            value={page.participationType || ''}
                            componentClass="select"
                            onChange={(e) => onVisibilityUpdate(page.id, 'participationType', e.target.value)}
                        >
                            {/* <option value="">
                                {locale.currentLocaleName === 'ru' ? 'Нет значения' : 'No value'}
                            </option> */}
                            {
                                EVENT_TYPES_OPTIONS.map((option) => (
                                    <option
                                        key={option.type}
                                        value={option.type}
                                    >
                                        {option[`name${capitalizer(locale.currentLocaleName)}`]}
                                    </option>
                                ))
                            }
                        </FormControl>
                    </FormGroup>
                }
            </td>
            <td>
                {
                    !isNotDeletablePageType &&
                    <FormGroup
                        controlId="default-open"
                        bsSize="sm"
                    >
                        <FormControl
                            value={page.defaultType || ''}
                            componentClass="select"
                            onChange={(e) => onUpdateDefaultType(page, e.target.value)}
                        >
                            <option value="">
                                {locale.currentLocaleName === 'ru' ? 'Нет значения' : 'No value'}
                            </option>
                            {
                                EVENT_TYPES_OPTIONS.map((option) => (
                                    <option
                                        key={option.type}
                                        value={option.type}
                                    >
                                        {option[`name${capitalizer(locale.currentLocaleName)}`]}
                                    </option>
                                ))
                            }
                        </FormControl>
                    </FormGroup>
                }
            </td>
            <td>
                <ButtonToolbar>
                    <Button
                        bsStyle="info"
                        bsSize="sm"
                        onClick={() => history.push(`${history.location.pathname}/edit/${page.id}`)}
                    >
                        Редактировать
                    </Button>
                    {
                        !isNotDeletablePageType &&
                        <>
                            <Button
                                bsStyle="success"
                                bsSize="sm"
                                onClick={() => pagesContext.handleUpdatePage({...page, visible: !page.visible})}
                            >
                                {page.visible ? 'Скрыть' : 'Показать' }
                            </Button>
                            <Button
                                bsStyle="danger"
                                bsSize="sm"
                                onClick={() => pagesContext.handleDeletePage(page.id)}
                            >
                                Удалить
                            </Button>
                        </>
                    }
                </ButtonToolbar>
            </td>
        </>
    )
}

export default PagesListTableItem;
